import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import Checkbox from '@mui/material/Checkbox';
import { numberToCurrencyString } from 'further-ui/utils';
import { CurrencyCode } from 'further-types/lp/vehicle';
import Table, { Column as TableColumn } from 'further-ui/components/Table';
import AvatarWithName from 'components/new/AvatarWithName';
import { Column } from 'further-ui/components/Layout';
import { styled } from '@mui/material';
import TypographyButton from 'further-ui/components/TypographyButton';

const StyledColumn = styled(Column)({ maxWidth: 600 });

type Props = {
  currency: CurrencyCode;
  disabled: boolean;
};

const WithholdingTaxExemptTable: React.FC<Props> = ({ currency, disabled }) => {
  const [expanded, setExpanded] = useState(false);

  const { control, watch } =
    useFormContext<rules.CreateRealisationFormValues>();
  const investorWithholdingTaxList = watch('investorWithholdingTaxList') || [];

  const rows = investorWithholdingTaxList.map((item, index) => ({
    ...item,
    id: item.commitmentId,
    key: item.commitmentId,
    label: item.investorName,
    group: 'Investors',
    index,
  }));

  const columns: Array<TableColumn<(typeof rows)[number]>> = [
    {
      key: 'label',
      label: 'Investor',
      render: (row) => <AvatarWithName name={row.label} />,
    },
    {
      key: 'totalCommitmentLcy',
      label: 'Total commitment',
      render: (row) =>
        numberToCurrencyString(row.totalCommitmentLcy, { currency }),
    },
    {
      key: 'withholdingTax',
      label: 'Opt out',
      render: (row) => (
        <Controller
          control={control}
          name={`investorWithholdingTaxList.${row.index}.withholdingTaxExempt`}
          render={({ field }) => (
            <Checkbox
              size="small"
              checked={field.value}
              onChange={(e) => {
                field.onChange(e.target.checked);
              }}
              disabled={disabled}
            />
          )}
        />
      ),
    },
  ];

  return (
    <StyledColumn fullWidth spacing="sm">
      <TypographyButton
        textDecoration="none"
        text="Opt individual LPs out of withholding tax"
        showExpandableStartAdornment
        isExpanded={expanded}
        onClick={() => setExpanded((prev) => !prev)}
      />
      {expanded && <Table columns={columns} rows={rows} />}
    </StyledColumn>
  );
};

export default WithholdingTaxExemptTable;
